import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyDIks4BrxH_KbgKxAR7GrsRPAXO2MwMGJg',
  authDomain: 'book-library-app-a858a.firebaseapp.com',
  projectId: 'book-library-app-a858a',
  storageBucket: 'book-library-app-a858a.appspot.com',
  messagingSenderId: '936382899064',
  appId: '1:936382899064:web:9a21be74a65e1c39315e8d',
};

// Initialize Firebase
initializeApp(firebaseConfig);
export const db = getFirestore();
